module.exports = __webpack_public_path__ + "img/checkout.67668c74.jpg";